
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { Database } from "@/integrations/supabase/types";

type UserProfile = Database['public']['Tables']['profiles']['Row'];

interface VerifyUserDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedUser: UserProfile | null;
  onVerifyUser: () => Promise<void>;
}

const VerifyUserDialog = ({ 
  open, 
  setOpen, 
  selectedUser, 
  onVerifyUser 
}: VerifyUserDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Verify User</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to verify {selectedUser?.name}? This action allows them to 
            {selectedUser?.role === "pollster" ? " submit poll responses." : " upload media content."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onVerifyUser}>
            Verify User
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default VerifyUserDialog;
